export default __webpack_public_path__ + "static/media/logo.4f602b5c.svg";